import { render } from "./PlanetaryTracks.vue?vue&type=template&id=666ad73e&ts=true"
import script from "./PlanetaryTracks.vue?vue&type=script&lang=ts"
export * from "./PlanetaryTracks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__